import { UserActions } from './userActions';

const UserActionsContainer = UserActions;

export { UserActionsContainer };
